import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { Printer } from "lucide-react";
import api from "@/lib/api";
import RequireUser from "@/components/public/RequireUser";
import { fmtDateTime } from "@/components/tournament/constants";

const real = (m) => ![m.a, m.b].some((x) => x === "BYE");

function Sheet() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const [t, setT] = useState(null);
  useEffect(() => { api.get(`/manage/tournaments/${id}`).then((r) => setT(r.data)); }, [id]);
  if (!t) return <div className="py-24 text-center text-white/40">Loading…</div>;
  const only = params.get("match");
  const ms = (t.bracket?.matches || []).filter((m) => real(m) && m.status !== "completed" && (!only || m.id === only));
  return (
    <div className="mx-auto max-w-5xl px-4 py-8 print:p-0 print:max-w-none" data-testid="qr-print-page">
      <div className="flex items-center justify-between mb-6 print:hidden">
        <div><h1 className="text-2xl font-bold text-white">Match QR codes</h1><p className="text-sm text-white/50">{t.name} · {ms.length} match(es). Place each QR at the match station.</p></div>
        <button onClick={() => window.print()} data-testid="qr-print-btn" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white text-black font-bold"><Printer size={16} /> Print</button>
      </div>
      <div className="grid sm:grid-cols-2 gap-5 print:grid-cols-2 print:gap-4">
        {ms.map((m) => (
          <div key={m.id} className="rounded-2xl bg-white text-black p-6 flex gap-5 items-center break-inside-avoid" data-testid={`qr-card-${m.id}`}>
            <QRCodeSVG value={`${window.location.origin}/report/${m.token}`} size={140} level="M" />
            <div className="min-w-0">
              <div className="text-[10px] font-bold tracking-widest uppercase text-gray-500">7 Legendary · Submit result</div>
              <div className="mt-1 font-bold text-lg leading-tight">{m.a} <span className="text-gray-400">vs</span> {m.b}</div>
              <div className="text-sm text-gray-600 mt-1">{m.round_name}{m.group ? ` · Group ${m.group}` : ""}</div>
              <div className="text-xs text-gray-500 mt-1">{m.scheduled_at ? fmtDateTime(m.scheduled_at) : "Time TBD"}</div>
              <div className="text-[10px] text-gray-400 mt-2">Captains: scan after the match ends.</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function PrintQR() {
  return <RequireUser><Sheet /></RequireUser>;
}
